
/// usage like: <div use:viewport on:enterViewport={handle} on:exitViewport={handle} />
export default function viewport(element: HTMLElement) {
    ensureIntersectionObserver();
    intersectionObserver?.observe(element);

    return {
        destroy() {
            intersectionObserver?.unobserve(element);
        }
    }
}

let intersectionObserver: IntersectionObserver | undefined;

function ensureIntersectionObserver() {
    if (intersectionObserver) return;

    intersectionObserver = new IntersectionObserver(
        (entries) => {
            entries.forEach(entry => {
                const eventName = entry.isIntersecting ? 'enterViewport' : 'exitViewport';
                entry.target.dispatchEvent(new CustomEvent(eventName));
            });
        }
    );
}